// extracted by mini-css-extract-plugin
export default {"wrapper":"calendar_wrapper__pRXRg","calendarInput":"calendar_calendarInput__Q9GOl","fullWidth":"calendar_fullWidth__gBjSP","fullHeight":"calendar_fullHeight__zLmcx"};